import Input from "../inputs/Input";
import { AiOutlineLoading } from "react-icons/ai";
import { Alert, Button } from "flowbite-react";
import useCEP from "../../hooks/useCEP";
import { useForm, Controller } from "react-hook-form";
import { AVATAR, USERS } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { useEffect, useState } from "react";
import CPFInput from "../inputs/CPFInput";
import PhoneInput from "../inputs/PhoneInput";
import { resetValuesForm } from "../../utils/utils";
import SelectInput from "../inputs/SelectInput";
import { HiInformationCircle } from "react-icons/hi";
import ImageInput from "../inputs/ImageInput";
import { useApplication } from "../../contexts/ApplicationContext";
import ReactInputMask from "react-input-mask";

const UserForm = ({
  user,
  fetchUsers,
  onClose,
  isOpen,
  type = "CREATE",
  companyId = null,
}) => {
  const { userPermission } = useApplication();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [key, setKey] = useState(0);
  const [error, setError] = useState(null);
  const [avatarImg, setAvatarImg] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (type === "EDIT" && user) {
      Object.keys(user).forEach((key) => {
        setValue(key, user[key]);
      });
      setPreviewUrl(user?.imageUrl);
      setAvatarImg(user?.avatar);
      setKey((prev) => prev + 1);
    } else if (type === "CREATE") {
      resetValuesForm(["cpf", "phoneNumber"], setValue, reset);
      setPreviewUrl("");
      setAvatarImg("");
    }
    setValue("password", "");
    setError(null);
  }, [user, isOpen]);

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);

      // if (previewUrl.includes("data:image/")) {
      //   const formData = new FormData();
      //   formData.append("image", avatarImg);
      //   const { data: avatar } = await axios.post(
      //     `${AVATAR.UPLOAD}?avatar=${user?.avatar || ""}`,
      //     formData,
      //     {
      //       headers: {
      //         "Content-Type": "multipart/form-data",
      //       },
      //     }
      //   );
      //   data.avatar = avatar.imageName;
      // }

      // if (user?.email !== data.email) {
      //   const responseEmail = await axios.get(
      //     `${USERS.GET_USER}/email/${data.email}`
      //   );

      //   if (responseEmail.status === "error") {
      //     throw new Error("E-mail já cadastrado");
      //   }
      // }

      if (type === "CREATE") {
        data.companyId = companyId;
        await axios.post(USERS.GET_USER, data);
      } else {
        if (data.password === "") delete data.password;

        await axios.put(`${USERS.GET_USER}/${user.id}`, data);
      }

      onClose(false);

      fetchUsers();

      if (type === "CREATE")
        resetValuesForm(["cpf", "phoneNumber"], setValue, reset);
    } catch (error) {
      setError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const {
    cep,
    setCep,
    address,
    loading: loadingCEP,
    error: errorCEP,
  } = useCEP();

  const onClickSearchCEP = (e) => {
    setCep(getValues("addressPostalCode"));
  };

  useEffect(() => {
    setValue("address", address?.logradouro);
    setValue("addressNeighborhood", address?.bairro);
    setValue("addressCity", address?.localidade);
  }, [address]);

  return (
    <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
      <div>
        <ImageInput
          image={avatarImg}
          setImage={setAvatarImg}
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Nome *" error={errors?.name?.message}>
          <input
            type="text"
            className={fieldClass}
            {...register("name", { required: "Informe o nome" })}
          />
        </Field>
        <Field label="Telefone *" error={errors?.phoneNumber?.message}>
          <Controller
            name="phoneNumber"
            control={control}
            rules={{ required: "Informe o telefone" }}
            render={({ field }) => (
              <ReactInputMask
                mask="(99) 99999-9999"
                maskChar=""
                {...field}
                className={fieldClass}
              />
            )}
          />
        </Field>
        <Field label="E-mail *" error={errors?.email?.message}>
          <input
            type="email"
            className={fieldClass}
            {...register("email", { required: "Informe o e-mail" })}
          />
        </Field>
        {["ADMIN", "POWER_USER"].includes(userPermission) && (
          <Field
            label={`Senha ${type === "CREATE" ? "*" : ""}`}
            error={errors?.password?.message}
          >
            <input
              type="password"
              className={fieldClass}
              {...register("password", {
                required: type === "CREATE" ? "Informe a senha" : false,
              })}
            />
          </Field>
        )}

        {["ADMIN", "POWER_USER"].includes(userPermission) && (
          <Field
            label="Permissão de usuário"
            error={errors?.permissionId?.message}
          >
            <select
              className={`${fieldClass} cursor-pointer`}
              {...register("permissionId")}
            >
              <option value="">Selecione uma permissão</option>
              {userPermission === "POWER_USER" && (
                <option value="POWER_USER">Power User</option>
              )}
              <option value="ADMIN">Administrador</option>
              <option value="USER">Usuário</option>
            </select>
          </Field>
        )}
      </div>
      <Button
        type="submit"
        className="w-full mb-48 md:mb-4 primary"
        isProcessing={isSubmitting}
        processingSpinner={
          <AiOutlineLoading className="h-6 w-6 animate-spin" />
        }
        disabled={isSubmitting}
      >
        {type === "CREATE" ? "Criar" : "Atualizar"} usuário
      </Button>

      {error && (
        <Alert color="failure" icon={HiInformationCircle}>
          {error?.config?.method !== "get"
            ? `Erro ao {error.config.method === "put" ? "atualizar" : "criar"}{" "}
          usuário`
            : "E-mail já cadastrado"}
        </Alert>
      )}
    </form>
  );
};

const fieldClass =
  "block w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 focus:border-slate-500 focus:ring-0";

const Field = ({ label, error, children }) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.3em] text-slate-500">
          {label}
        </span>
        {error && <span className="text-[10px] text-rose-600">{error}</span>}
      </div>
      {children}
    </div>
  );
};

export default UserForm;
